<template>
  <div data-luko-tracking="SlicesArea">
    <div v-for="(slice, index) in slices" :key="'slice-' + index">
      <component
        :is="componentName(slice)"
        v-if="componentName(slice)"
        :slice="slice"
      />
    </div>
  </div>
</template>

<script>
import { TrustpilotCarousel, SimpleSlice } from '@@/shared-slices'

import {
  AlternatingBlocks,
  ArticlesList,
  BottomBanner,
  FaqSection,
  Hero,
  HeroFullImage,
  HighlightBlockSlice,
  IconListSlice,
  QuinconceSlice,
  QuoteSlice,
  RichTextSlice,
  ScrollableList,
  SensorListSlice,
  TableSlice,
  BundleProductSlice,
  HorizontalListSlice,
  VimeoSection,
  CardSlice,
  ArticleSlice,
  SimpleSection,
  TextIconSection,
  ButtonSlice,
  EmbedCalendly,
  GivebackSchema,
} from '~/components/slices'
import { findComponentByType } from '~/utils/slices'

export default {
  name: 'SlicesArea',

  components: {
    AlternatingBlocks,
    ArticlesList,
    BottomBanner,
    FaqSection,
    Hero,
    HeroFullImage,
    HighlightBlockSlice,
    IconListSlice,
    QuinconceSlice,
    QuoteSlice,
    RichTextSlice,
    ScrollableList,
    SensorListSlice,
    TableSlice,
    TrustpilotCarousel,
    BundleProductSlice,
    HorizontalListSlice,
    VimeoSection,
    CardSlice,
    ArticleSlice,
    SimpleSection,
    SimpleSlice,
    TextIconSection,
    ButtonSlice,
    EmbedCalendly,
    GivebackSchema,
  },

  props: {
    slices: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    componentName() {
      return ({ slice_type }) => findComponentByType(slice_type)
    },
  },
}
</script>

<style lang="scss" module></style>
